module.exports = __webpack_public_path__ + "img/4f902e7.png";